class TableNameInputModel {
    id: number;
    isPrincipal: boolean;
    tableName: string;
    originalName: string;
    fields: Array<FieldNameInputModel>;
    get visibleFields() {
        return this.fields.filter(x => x.visibility === VisibilityEnum.Normal);
    }

    schemaField: boolean;
    visibility: VisibilityEnum;
    order: number;
    get nodeId() { return `${this.tableName}-${this.id}`; }
    get nodeName() { return this.tableName; }

    get internalDisplayName() {
        return this.tableName;
    }

    constructor(data) {
        this.id = data.id;
        this.isPrincipal = data.isPrincipal;
        this.tableName = data.tableName;
        this.originalName = data.originalName;
        this.schemaField = data.schemaField;
        this.visibility = data.visibility;
        this.order = data.order;
        this.fields = createInstances(FieldNameInputModel, data.fields);
    }

    clone(): TableNameInputModel {
        return new TableNameInputModel(this);
    }
}